import queryString from "query-string";

export default function(page, setParams = true) {
    event.preventDefault();
    let q = queryString.parse(window.location.href.split('?')[1]);
    q.page = page;
    let url = window.location.href.split('?')[0];
    if(setParams)
    {
        url += '?' + queryString.stringify(q);
    }
    window.history.replaceState('', '', url);
}
